/* import __COLOCATED_TEMPLATE__ from './project-create-find-freelancer-result.hbs'; */
import Component from '@glimmer/component';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { APPLICATION } from 'sh-www/models/application';
import { showModal } from 'sh-www/utils/modal-controls';
import { restartableTask } from 'ember-concurrency';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-posting-create-find-freelancer-result';
const RELATIONSHIP_DETAILS_CLASS_NAME = `${CLASS_NAME}__relationship-details__network-status`;

class PostingCreateFindFreelancerResult extends Component {
  @service('error-tracker') errorTracker;
  @service router;
  @service session;
  @service media;
  @service('state-managers/routes/posting-create') stateManager;
  @service('commands/application-commands') applicationCommandService;

  #currentCompanyConnection = createCache(() => {
    return this.args.user.companySellerConnections.find(({ companyId }) => this.session.currentUser.company.id == companyId);
  });

  #extendedNetwork = createCache(() => {
    return this.args.user.companySellerConnections.reduce((extendedNetwork, connection) => {
      if (connection.invited && connection.id !== this.currentCompanyConnection.id) {
        extendedNetwork.push(connection);
      }
      return extendedNetwork;
    }, []);
  });

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      'LSG-l-grid justify-center',
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get relationshipDetailsClassNames() {
    return clsx(
      RELATIONSHIP_DETAILS_CLASS_NAME,
      (this.userInNetwork || this.userInExtendedNetwork) && 'lsg-green',
    );
  }

  get hireButtonDisabled() {
    return this.hireFreelancer.isRunning;
  }

  get currentCompanyConnection() {
    return getValue(this.#currentCompanyConnection)
  }

  get userInNetwork() {
    return this.currentCompanyConnection.invited;
  }

  get userInExtendedNetwork() {
    return !this.userInNetwork && this.currentCompanyConnection.inExtendedNetwork;
  }

  get extendedNetwork() {
    return getValue(this.#extendedNetwork);
  }

  get extendedNetworkCompanyName() {
    if (this.extendedNetwork.length > 1) {
      return 'Multiple companies'
    }
    
    return this.extendedNetwork?.[0].company.name ?? null;
  }

  get relationshipDetailsText() {
    if (this.userInNetwork) {
      return 'In-network';
    } else if (this.userInExtendedNetwork) {
      return 'Extended network';
    } else {
      return 'Out-of-network';
    }
  }

  @restartableTask
  *hireFreelancer() {
    const currentUser = this.session.currentUser;
    const freelancer = this.args.user;

    if (currentUser.company.isNeedsCreditCard) {
      return showModal(
        this,
        'payments/stripe-cc-modal',
        {
          seller: freelancer,
          onSuccess: () => this.hireFreelancer.perform(),
        }
      );
    }

    try {
      const dashboardApplicationList = yield this.applicationCommandService.loadApplications(
        undefined,
        APPLICATION.SIMPLE_STATUS.IN_PROGRESS,
        undefined,
        false,
        undefined,
        1,
        20,
        undefined,
        '',
        freelancer.id,
        currentUser.company.id
      );
      
      const freelancerProjects = dashboardApplicationList.applications;
  
      if (freelancerProjects.length) {
        const modalData = {
          freelancer,
          freelancerProjects,
        };
  
        showModal(this, 'projects/existing-projects-modal', modalData);
      } else {
        this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__CREATE__DIRECT, freelancer.slug);
      }
    } catch (e) {
      this.errorTracker.error(e, this, `could not hire freelancer with id ${freelancer.id}`);
    }
  }
}

export default PostingCreateFindFreelancerResult;
